import { useLocation } from 'react-router';

export default function useIsMyScoopr() {
  const location = useLocation();

  return location.pathname.startsWith('/min-scoopr');
}
